// src/features/userManagement/services/screenService.js
//
// Screen catalog + per-user screen-grant API client.
// Talks directly to IAM with the Bearer token from localStorage
// (mirrors userManagementService.js).

import axios from 'axios';
import { API as ApiUrls } from '../../../utils/apiUrls';

function authHeaders() {
  return { Authorization: localStorage.getItem('authToken') || '' };
}

/**
 * List every screen in the catalog.
 * @returns {Promise<Array<{id:number, screen_name:string, screen_url:string, merchant_allowed:boolean}>>}
 */
export async function listAllScreens() {
  const resp = await axios.get(ApiUrls.iamScreensAll(), { headers: authHeaders() });
  return resp.data;
}

/**
 * List the screens assigned to a role (used to seed a new user's defaults).
 * @param {number} roleId
 */
export async function listRoleScreens(roleId) {
  const resp = await axios.get(ApiUrls.iamScreensByRole(roleId), { headers: authHeaders() });
  return resp.data;
}

/**
 * Get a user's explicit per-user screen grants.
 * @returns {Promise<Array<{screen_id:number, screen_name:string, screen_url:string, access_level:string}>>}
 */
export async function getUserScreens(organizationId, clientId) {
  const resp = await axios.get(ApiUrls.iamOrgUserScreens(organizationId, clientId), { headers: authHeaders() });
  return resp.data;
}

/**
 * Replace a user's full screen-grant set.
 * @param {Array<{screen_id:number, access_level:'READ'|'READ_WRITE'}>} screens
 */
export async function setUserScreens(organizationId, clientId, screens) {
  const resp = await axios.put(
    ApiUrls.iamOrgUserScreens(organizationId, clientId),
    { screens },
    { headers: authHeaders() }
  );
  return resp.data;
}
